const loadESG = () => {
  if (document.querySelector('.esg-issuu-wrapper')) {
    const issuuElementWrapper = document.querySelector('.esg-issuu-wrapper');
    const issuuElement = document.getElementById('esg-issuu');
    const esgClose = document.querySelector('.close-button');
    const esgButtons = Array.from(document.querySelectorAll('.esg-issuu-button'));

    esgButtons.forEach(button => {
      const dataValue = button.getAttribute('data-value');

      button.addEventListener('click', () => {
        issuuElementWrapper.classList.add('active');
        issuuElement.innerHTML = `<iframe allow='clipboard-write' sandbox='allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms' allowfullscreen='true' src='https://e.issuu.com/embed.html?d=upload_20231021-031233&u=sloan2023&pageLayout=singlePage&pageNumber=${dataValue}'></iframe>`;
      });
    });

    esgClose.addEventListener('click', () => {
      issuuElementWrapper.classList.remove('active');
      issuuElement.innerHTML = '';
    });
  }
};

export default loadESG;
